import styled, { css } from 'styled-components';

const colorStyle = (p) => {
  let val;

  if (p.isSubtle) {
    val = p.theme.alias.subtle;
  } else if (p.isDanger) {
    val = p.theme.alias.danger;
  } else if (p.isPrimary) {
    val = p.theme.alias.primary;
  }

  return css`
    color: ${val};
  `;
};

export const StyledText = styled.div`
  ${(p) => colorStyle(p)};
  display: inline;
  font-weight: ${(p) => p.isBold && 500};
`;
